import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { send } from "@emailjs/browser";
import { EMAIL_CONFIG } from "../../config/emailConfig";
import "./Contacto.css";

export default function Contact() {
  const { t } = useTranslation("contacto");

  const formRef = useRef();
  const [status, setStatus] = useState("");
  const [submittedData, setSubmittedData] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const sendContactEmail = (params) => {
    const config = EMAIL_CONFIG.es;

    return send(config.serviceId, config.contactId, params, config.publicKey);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const form = formRef.current;
    const name = form.user_name.value;
    const email = form.user_email.value;
    const message = form.user_message.value;

    if (!name || !email || !message) return;

    const params = { name, email, message };

    setStatus(t("status.sending", { defaultValue: "Enviando..." }));

    sendContactEmail(params)
      .then(() => {
        setSubmittedData({ name, email, message });
        setStatus(t("status.success"));
        form.reset();
      })
      .catch((err) => {
        console.error("EmailJS Error:", err);
        setStatus(t("status.error"));
      });
  };

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero__inner">
          <h1>{t("title")}</h1>

          <p>{t("desc")}</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="contact-inner">
          <div className="contact-form-card">
            {!submittedData ? (
              <form
                ref={formRef}
                className="contact-form"
                onSubmit={handleSubmit}
              >
                <label>
                  <span className="contact-label-text">
                    {t("form.name")}
                    <small>{t("form.required")}</small>
                  </span>

                  <input
                    name="user_name"
                    type="text"
                    required
                    placeholder={t("form.placeholderName")}
                  />
                </label>

                <label>
                  <span className="contact-label-text">
                    {t("form.email")}
                    <small>{t("form.required")}</small>
                  </span>

                  <input
                    name="user_email"
                    type="email"
                    required
                    placeholder={t("form.placeholderEmail")}
                  />
                </label>

                <label>
                  <span className="contact-label-text">
                    {t("form.message")}
                    <small>{t("form.required")}</small>
                  </span>

                  <textarea
                    name="user_message"
                    required
                    placeholder={t("form.placeholderMessage")}
                  />
                </label>

                <button type="submit">{t("form.submit")}</button>

                {status && <p className="contact-status">{status}</p>}
              </form>
            ) : (
              <div className="contact-summary">
                <span className="contact-summary__eyebrow">
                  {t("summary.eyebrow")}
                </span>

                <h2>{t("summary.title")}</h2>

                <div className="contact-summary__content">
                  <p>
                    <strong>{t("summary.name")}:</strong> {submittedData.name}
                  </p>

                  <p>
                    <strong>{t("summary.email")}:</strong> {submittedData.email}
                  </p>

                  <p>
                    <strong>{t("summary.message")}:</strong>{" "}
                    {submittedData.message}
                  </p>
                </div>

                <p className="contact-status contact-status--after">{status}</p>
              </div>
            )}
          </div>

          <aside className="contact-side-card" aria-label="Contact information">
            <div className="contact-side-card__glow" />

            <h2>{t("side.title")}</h2>

            <p>{t("side.text")}</p>

            <div className="contact-side-card__list">
              {t("side.items", { returnObjects: true }).map((item) => (
                <div key={item}>
                  <span />
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
}
